import { IPatientAttachment } from "../models/IPatientAttachment";
import * as Utils from "../utils/Config";
import { ApiClient } from "./ApiClient";

export class PatientAttachmentApi extends ApiClient {

    getPatientAttachments(patientId: number, success: (data: IPatientAttachment[]) => void, error?: (message: string) => void) {
        this.get<IPatientAttachment[]>(`${Utils.LIB_API_BASE_URL}/patientAttachments/patient/${patientId}`, success, error);
    }

    uploadPatientAttachments(patientId: number, data: any, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/patientAttachments/patient/${patientId}`, data, success, error, final);
    }

    downloadPatientAttachment(patientAttachmentId: number, fileName?: string, error?: (message: string) => void) {
        this.getFile(`${Utils.LIB_API_BASE_URL}/patientAttachments/${patientAttachmentId}`, fileName ?? "", undefined, error);
    }

    deletePatientAttachment(patientAttachmentId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/patientAttachments/${patientAttachmentId}`, success, error, final);
    }
}